var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouseReleases(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.5H18v2.465m-.381-2.465a6.66 6.66 0 01-2.646 2.682A6.57 6.57 0 016 16.5M12 7V3M3 13V7.828a2 2 0 01.586-1.414l2.828-2.828A2 2 0 017.828 3h8.344a2 2 0 011.414.586l2.828 2.828A2 2 0 0121 7.828V13M3.183 7h17.635",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  })));
}
export default SvgWarehouseReleases;